import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function helixMultiEntityReducer(state = initialState.helixMultiEntityImport, action) {
	switch (action.type) {
		case types.GET_HELIX_CONNECTION_ENTITIES: {
			return action.response;
		}
		case types.CLEAR_HELIX_CONNETION_ENTITIES: {
			return initialState.helixMultiEntityImport;
		}
		default:
			return state;
	}
}
